import React from "react";
import { ForumsTopicPostsContainer } from "../../../containers/forums/ForumsTopicPostsContainer";
import { useForumsNavigation } from "../../../hooks/useForumNavigation";
import { BANNER_FORUM_HOST_PAGE } from "../../../utilities/assets/assetHelper";
import { EForumTopic } from "../../../utilities/forums";
import { useTranslation } from "react-i18next";

export const ForumsHostPage = () => {
    const { t } = useTranslation();
    const { navigateToNewPost, navigateToArticle, navigateToPost } = useForumsNavigation()

    const handleCreateNewPost = () => {
        navigateToNewPost(EForumTopic.HOST)
    }

    return <ForumsTopicPostsContainer
        topic={EForumTopic.HOST}
        banner={{
            title: t('forum.host.title'),
            backgroundImageSrc: BANNER_FORUM_HOST_PAGE,
            subTitle: t('forum.host.subTitle'),
            primaryButton: { text: t('forum.topic.newPostButton'), onClick: handleCreateNewPost }
        }}
        onCreateNewPostClick={handleCreateNewPost}
        navigateToPost={navigateToPost}
        navigateToArticle={navigateToArticle} />
}